var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiseHandWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7081 3C10.7081 2.73478 10.8141 2.48043 11.0028 2.29289C11.1915 2.10536 11.4475 2 11.7143 2C11.9812 2 12.2371 2.10536 12.4258 2.29289C12.6145 2.48043 12.7206 2.73478 12.7206 3V10.3058C13.183 10.4498 13.6329 10.6453 14.0622 10.8916V4.33333C14.0622 4.06812 14.1682 3.81376 14.3569 3.62623C14.5456 3.43869 14.8015 3.33333 15.0684 3.33333C15.3353 3.33333 15.5912 3.43869 15.7799 3.62623C15.9686 3.81376 16.0746 4.06812 16.0746 4.33333V14.0551C15.4587 14.1587 14.8755 14.4032 14.371 14.7693C13.8666 15.1354 13.4546 15.613 13.1678 16.1644C14.2795 15.6159 15.5042 15.3314 16.7454 15.3333C16.9233 15.3333 17.094 15.2631 17.2198 15.1381C17.3456 15.013 17.4162 14.8435 17.4162 14.6667V12.6524C17.4193 11.8618 17.737 11.1045 18.2999 10.5458C18.4901 10.3659 18.7434 10.2669 19.006 10.2701C19.2685 10.2732 19.5194 10.3782 19.7051 10.5627C19.8908 10.7471 19.9966 10.9964 19.9999 11.2573C20.0033 11.5182 19.9039 11.77 19.7229 11.9591C19.6299 12.0512 19.556 12.1606 19.5055 12.2811C19.455 12.4016 19.4289 12.5308 19.4287 12.6613V15.3333H19.4242C19.3714 16.6742 18.8118 17.9461 17.8572 18.8951L16.3045 20.4382C15.2982 21.4382 13.9334 21.9999 12.5104 22H10.7081C8.92902 22 7.22278 21.2976 5.96476 20.0474C4.70675 18.7971 4 17.1014 4 15.3333V7C4 6.73478 4.10601 6.48043 4.29471 6.29289C4.48342 6.10536 4.73935 6 5.00622 6C5.27308 6 5.52902 6.10536 5.71772 6.29289C5.90642 6.48043 6.01244 6.73478 6.01244 7V11.9058C6.42387 11.504 6.87555 11.1662 7.35406 10.8916V4.33333C7.35406 4.06812 7.46007 3.81376 7.64878 3.62623C7.83748 3.43869 8.09341 3.33333 8.36028 3.33333C8.62715 3.33333 8.88308 3.43869 9.07178 3.62623C9.26049 3.81376 9.3665 4.06812 9.3665 4.33333V10.1342C9.80923 10.0453 10.2582 10 10.7081 10V3Z",
    fill: "url(#paint0_linear_197_5108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_5108",
    x1: 4,
    y1: 2,
    x2: 23.5122,
    y2: 17.6098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHandWhite);
export default __webpack_public_path__ + "static/media/raise-hand-white.aa2f6c4bb1dfae77aac21ce31039e3f7.svg";
export { ForwardRef as ReactComponent };